import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { LogAcessoView } from '../core/_models'
import { LogsUsuarioIdColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const LogsUsuarioIdTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { t } = useT()

  const columns = useMemo(() => LogsUsuarioIdColumns(t), [t])

  return (
    <CustomTable<LogAcessoView>
      id='kt_table_usuario_id'
      ariaLabel='Logs do usuário'
      itemLabel={{ singular: 'registro', plural: 'registros' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhum registro para este usuário'
          description='Os acessos e requisições do usuário aparecem aqui.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
